const esgConfig = {
	svcHost: process.env.REACT_APP_PROXY_TARGET + process.env.REACT_APP_API_HOST,
	//fetch ohi login
	fetchLogin: {
		method: 'GET',
		url: '/logon',
		timeout: 60000
	},
	//fetch questionnaires by doc id
	fetchQuestionnaires: {
		method: 'GET',
		url: '/questionnaires/70',
		timeout: 60000
	},
	//fetch questionnaires by doc id
	fetchQuestionnairesResult: {
		method: 'GET',
		url: '/questionnaires/responses',
		//url: '/channel/getResult.json',
		timeout: 60000
	},
	responses: {
		method: 'POST',
		url: '/questionnaires/responses',
		timeout: 60000
	},

	//wealth msg api
	fetchQuestionnaires_wealth: {
		method: 'GET',
		url: `/questionnaires/${process.env.REACT_APP_QUES_ID}`,
		timeout: 60000
	},
	//fetch questionnaires by doc id
	fetchQuestionnairesResult_wealth: {
		method: 'GET',
		url: `/questionnaires/${process.env.REACT_APP_QUES_ID}/responses`,
		//url: '/channel/getResult.json',
		timeout: 60000
	},
	responses_wealth: {
		method: 'POST',
		url: `/questionnaires/${process.env.REACT_APP_QUES_ID}/responses`,
		timeout: 60000
	},
	retrieveReportGenerate: {
		//url: '/gateway/controller/rge/restful/wealth/api/v1/reports/reportGenerate',
		url: '/rge/wealth/api/v1/reports/reportGenerate',
		method: 'POST',
		timeout: 60000
	},

	retrieveReportDocumnetId: {
		url: '/rge/wealth/api/v1/reports/{reportId}',
		method: 'GET',
		timeout: 60000
	},
	downloadEsgReport: {
		url: '/sfpapi/document', //'/sfpapi/api/v1/document', //
		method: 'GET',
		requestKey: 'docId',
		timeout: 60000
	},

	reportType: 'GEN-ESG',
	reportTitle: 'ESG Preference Questionnaire Report',
	reportGeneratePath: (process.env.REACT_APP_CHANNEL_CODE === 'HK') ? 'http://sfp-api-service.gpb/sfp-api/api/v1/esg/esgReport' :
		'http://sfp-api-service/sfp-api/api/v1/esg/esgReport',
	getDocIdTimeInterval: 3000,
	getDocIdTimeIntervalMaxCall: 5
};

export default esgConfig;
